import { createContext } from 'react'
import { BuildInfo } from '../AppVersion/types'

export type ColorMode = 'light' | 'dark'

export interface CiboUiContextValue {
  buildInfo: BuildInfo
  colorMode: {
    toggleColorMode(): void
    currentMode: ColorMode
  }
  events: EventTarget
  setIsEmulated: (isEmulated: boolean) => void
}

export const CiboUiContext = createContext<CiboUiContextValue>({
  buildInfo: {
    releaseName: '',
    gitHash: '',
    buildDate: '',
  },
  colorMode: {
    toggleColorMode: () => {},
    currentMode: 'light',
  },
  events: new EventTarget(),
  setIsEmulated: (isEmulated: boolean) => {
    console.warn('CiboUiContext.setIsEmulated is not implemented')
  },
})
CiboUiContext.displayName = 'CiboUiContext'
